import useThemeCookie, { BASIC } from "shared/model/useThemeCookie"
import useColorCookie from "shared/model/useColorCookie"
import blackLogo from "shared/asset/logo.png"
import whiteLogo from "shared/asset/logo-white.png"

const parseHexToRgb = (hex) => {
    if (!hex || typeof hex !== "string") return { r: 255, g: 255, b: 255 }
    let clean = hex.trim()
    if (clean.startsWith("#")) clean = clean.slice(1)
    if (clean.length === 3) {
        const r = clean[0]
        const g = clean[1]
        const b = clean[2]
        clean = `${r}${r}${g}${g}${b}${b}`
    }
    const int = parseInt(clean, 16)
    if (Number.isNaN(int)) return { r: 255, g: 255, b: 255 }
    return {
        r: (int >> 16) & 255,
        g: (int >> 8) & 255,
        b: int & 255,
    }
}

const getPerceivedBrightness = ({ r, g, b }) => {
    // ITU-R BT.601 luma transform
    return 0.299 * r + 0.587 * g + 0.114 * b
}

const useLogoByBackground = () => {
    const [themeCookie] = useThemeCookie()
    const [colorCookie] = useColorCookie()

    const bg = themeCookie === BASIC
        ? colorCookie?.basic?.bg
        : colorCookie?.gradation?.bg

    const rgb = parseHexToRgb(bg)
    const brightness = getPerceivedBrightness(rgb)
    const isDark = brightness < 128

    return isDark ? whiteLogo : blackLogo
}

export default useLogoByBackground


